<template>
  <section
    ref="con"
    class="detail-page-container">
    <section class="main-container">
      <div
        class="main-header"
        :class="{
          'black': [0].includes(detailData.customer_profile.status),
          'red':!!detailData.customer_profile.deleted_at
        }"
      >
        <span
          v-if=" detailData.customer_profile.id"
          class="hcid "> <span>{{ detailData.customer_profile.id }}</span></span>
        <div class="flex-sb">
          <div class="flex-align-center">
            <span class="mg-r-15">
              <div class="qr_avatar">
                <img
                  v-if="customer_profile.avatar_thumb_url"
                  ref="img"
                  :src="customer_profile.avatar_thumb_url">
                <template v-else>
                  <img
                    v-if="customer_profile.identity==1"
                    src="@/assets/images/icon/Personal-icon.png">
                  <img
                    v-else
                    src="@/assets/images/icon/Company-icon.png">
                </template>

              </div>
            </span>
            <div >

              <div class="header-title">
                <!-- <span class="icon">
                  <font-awesome-icon
                    :class="{'orange': detailData.customer_profile.is_flagged}"
                    :icon="detailData.customer_profile.is_flagged? 'person-circle-exclamation' : 'user'" />
                </span> -->
                <span
                  class="table-icon__img ">
                  <img :src="getOptionName('serverTypeIcon',merchant_platform)" >
                </span>
                <span class="circle mg-l-15">{{ detailData.customer_profile.identity == 1?'Personal':'Company' }}</span>
                <span
                  v-if="detailData.customer_profile.vip_level!=-1"
                  :class="{'blue_2':detailData.customer_profile.vip_level==1}"
                  class="fs-12 text-italic mg-l-15">{{ getOptionName('vip_level_list', detailData.customer_profile.vip_level) }}</span>
                <h3 :class="{'unname':withoutNickName}">{{withoutNickName? 'Unnamed Account' : detailData.customer_profile.nick_name}}</h3>
                <span
                  v-if="detailData.customer_profile.deleted_at"
                  class="header-date mg-r-3 color-del fs-12">Deleted at:
                  <span class="number-fontsize">{{ detailData.customer_profile.deleted_at }}</span>
                </span>
                <span
                  class="flex flex-align-center">
                  <font-awesome-icon
                    v-if="[0,1].includes(detailData.customer_profile.user_agreement_1)"
                    icon="square-check"
                    class="mg-r-3 fs-12"
                    :class="{'pending_verify-color':detailData.customer_profile.user_agreement_1==0,'verified-color':detailData.customer_profile.user_agreement_1==1} "></font-awesome-icon>
                  <span
                    class="fs-12"
                    :class="{
                      'pending_verify-color': detailData.customer_profile.user_agreement_1 ==0,
                      'verified-color': detailData.customer_profile.user_agreement_1 == 1,
                    }">{{getOptionName('user_agreement_option',detailData.customer_profile.user_agreement_1) }}</span>
                </span>
              </div>

              <div>
                <!-- <span class="span-status">
                <font-awesome-icon icon="pen-nib" />
                Incomplete
              </span> -->
                <span
                  class="span-status mg-l-10"
                  :class="{
                    'orange': [2].includes(detailData.customer_profile.status),
                    'green': [1].includes(detailData.customer_profile.status),
                    'red': [0].includes(detailData.customer_profile.status)
                  }">

                  {{ detailData.customer_profile.status_language }}
                </span>
                <span
                  v-if="detailData.customer_profile.is_tier_base"
                  class="span-status blue">
                  Professional
                </span>
                <span
                  v-if="detailData.customer_profile.verify_language"
                  class="span-status"
                  :class="{
                    'verified': detailData.customer_profile.verified == 20,
                    'pending_verify ': detailData.customer_profile.verified == -1,
                    'not_verify': detailData.customer_profile.verified == -2
                  }">
                  {{ detailData.customer_profile.verify_language }}
                </span>
                <span
                  v-if="detailData.customer_profile.is_flagged"
                  class="span-status flag">
                  Flagged
                </span>
                <span class="header-date">Created: <span
                  class="number-color number-fontsize">{{ detailData.customer_profile.created_at }}</span></span>
                <span class="header-date">Last Login: <span
                  class="number-color number-fontsize">{{ detailData.customer_profile.last_login_time }}</span></span>
              </div>

            </div>
          </div>
          <div class="form-item">
            <span class="title">Assignee</span>
            <v-select
              v-model="assigneeId"
              icon="user-nurse"
              :list="assigneeList"
              :clearable="true"
              @change="changeAssignee"/>
          </div>
        </div>
        <div>
          <el-tabs
            v-model="activeTab"
            @tab-click="handleClickTab">
            <el-tab-pane
              v-for="(tab, index) in tabList"
              :key="index"
              :label="tab.label"
              :name="tab.name"
            ></el-tab-pane>
            <!--<el-tab-pane name="uploadTab">
              <span
                slot="label"
                class="flex flex-tab"
              >
                <span>Upload Request</span>
                <span
                  v-if="hasDot"
                  class="dot"></span>
              </span>
            </el-tab-pane>-->
          </el-tabs>
        </div>

      </div>
      <div class="warning">
        <block-warning
          v-if="detailData.customer_profile.block_data && detailData.customer_profile.block_data.length"
          :customerProfile="detailData.customer_profile"></block-warning>
      </div>

      <subscribe-membership
        v-if="showSubscribe"
        :remark="remarkList"
        :form="detailData"
        :is-fina="isFina"
        :customer="detailData.customer_profile"></subscribe-membership>

      <div
        v-else
        class="main-body">
        <section class="main-content">

          <router-view
            ref="child"
            @switch="switchActiveTab"
            @update="getUpdateAccountData"
            @changeTab="handlerTab"
            @review="changeApproveAccount"
            @tab="handlerTab"
            @refresh="handlerRefresh"
            @changeEmail="changeEmail"></router-view>
        </section>
        <aside>
          <div
            v-if="showReviewIdentification"
            class="card backgroundCar">
            <span class="title">
              {{
                detailData.customer_profile.identity == 1 ?
                  'The identification document of this account is waiting approval.' :
                  'This account is pending approval'
              }}
            </span>

            <v-button
              size="small"
              class="mg-b-15"
              plain
              @click="changeApproveAccount">Review
            </v-button>

          </div>
          <div class="card">

            <v-button
              gray
              icon="plus"
              @click="newTicketClick">New General Ticket
            </v-button>

            <v-button
              gray
              icon="user-slash"
              :disabled="!detailData.customer_profile.id_no"
              @click="editUserBlocks">Edit User Blocks
            </v-button>

            <v-button
              gray
              class="mg-b-15"
              icon="circle-exclamation"
              @click="editFlag">{{detailData.customer_profile.is_flagged? 'Unflag User' : 'Flag User'}}</v-button>

            <contact-customer
              :customerId="customerId"
              :phone="detailData.customer_profile? detailData.customer_profile.phone: ''"
              :email="detailData.customer_profile? detailData.customer_profile.send_email: ''"
              :customerName="detailData.customer_profile? detailData.customer_profile.nick_name: ''"
              @success="updateMessageData"/>
          </div>

          <div class="card">
            <div class="flex-sb">
              <span class="title">Description</span>
              <span
                class="edit"
                @click="editDescription">Edit</span>
            </div>
            <div
              class="description-content"
              v-html="customer_description">
            </div>
          </div>

          <div class="card">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkList"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.cs_name }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                @keyEnter="handlerAddRemark"/>
              <v-button
                size="small"
                type="primary"
                @click="handlerAddRemark">Add Remark
              </v-button>
            </div>
          </div>
        </aside>
      </div>

    </section>
    <!-- dialog -->
    <new-general-ticket
      ref="new-general-ticket"
      :customer= "customer"
      :form="ticketParams"/>
    <approve-account-dialog
      ref="approveAccount"
      :detail="detailData"
      :form="detailData.customer_profile"
      @refresh="handleRefresh">
    </approve-account-dialog>

    <edit-description
      ref="edit-description"
      :detailData="detailData.customer_profile"
      :customerId="customerId"
      @update="getUpdateAccountData"></edit-description>

    <edit-user-blocks
      ref="edit-user-blocks"
      :customerId="customerId"
      :detailData="detailData.customer_profile"
      @update="getUpdateAccountData"></edit-user-blocks>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import approveAccountDialog from '@/views/accounts/dialog/approveAccountDialog'
import {addAccountRemark, flagEdit, getAccountDetail, setAccountCs} from '@/api/account'

import ContactCustomer from '@/views/components/contact-customer'
import NewGeneralTicket from '@/views/tickets/dialogs/new-general-ticket'

import EditDescription from './dialog/edit-description.vue'
import EditUserBlocks from './dialog/edit-user-blocks.vue'
import BlockWarning from '@/views/components/block-warning'
import SubscribeMembership from './components/subscribe-membership.vue'

export default {
  name: 'Detail',
  components: {
    ContactCustomer,
    NewGeneralTicket,
    approveAccountDialog,
    EditDescription,
    EditUserBlocks,
    BlockWarning,
    SubscribeMembership
  },
  mixins: [MixinOptions],
  data() {
    return {
      contactMethod: 0,
      type: '1', // 公司 or 個人
      activeTab: 'Home',
      methodsList: ['Notification', 'SMS', 'WhatsApp', 'Email'],
      newTicketDialog: false,
      detailData: {
        customer_profile: {}
      },
      assigneeId: '',
      message: '',
      remarkList: [],
      isDot:false,
      showSubscribe: false
    }
  },
  provide(){
    return {
      detailData : () => this.detailData,
      customer_id: () => this.customerId,
      merchant_platform:() => this.merchant_platform,
    }
  },
  computed: {
    isFina(){
      let {merchant_platform} = this.customer_profile||{}
      return merchant_platform == 2
    },
    merchant_platform(){
      let {merchant_platform} = this.customer_profile||{}
      return merchant_platform
    },
    tabList(){
      return  [
        {
          label: 'Home',
          name: 'homeTab'
        },
        {
          label: 'Profile',
          name: 'profileTab'
        },
        {
          label: 'Quote',
          name: 'quoteTab'
        },
        {
          label: 'Policies',
          name: 'policyTab'
        },
        {
          label: 'Tickets',
          name: 'ticketTab'
        },
        {
          label: this.isFina?'Fin Dollars/Member':'HD/Member',
          name: 'hdTab'
        },
        {
          label: 'Coupons',
          name: 'couponsTab'
        },
        // {
        //   label: 'Referral Request',
        //   name: 'referralTab'
        // },
        {
          label: 'Log',
          name: 'messageTab'
        }
      ]
    },
    customerId() {
      return this.$route.query.customer_id
    },
    ticketParams() {
      const {customer_profile = {}} = this.detailData
      const {id, cs_id,cs_name,merchant_platform} = customer_profile
      return {
        assignee_id: cs_id,
        customer_id: id,
        merchant_platform
      }
    },
    customer(){
      const {customer_profile = {}} = this.detailData
      const {cs_name} = customer_profile
      return {
        isrd_nm: cs_name,
      }
    },
    customer_profile(){
      const {customer_profile = {}} = this.detailData
      return customer_profile
    },
    showReviewIdentification() {
      const { customer_profile = {} } = this.detailData
      const { verified, identity, id_type_pic, status } = customer_profile || {}

      if(!id_type_pic) return true

      return this.activeTab == 'Profile' && verified<1 ||
        identity!=1 && verified<1 || status == 2
    },
    hasDot(){
      return this.isDot
    },
    withoutNickName(){
      if(this.detailData.customer_profile && this.detailData.customer_profile.nick_name && this.detailData.customer_profile.nick_name.trim()){
        return false
      }
      return true
    },
    customer_description(){
      let str = this.detailData.customer_profile.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        if(this.customerId){
          this.network().getAccountDetail()
        }
      }
    },
    customerId:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getAccountDetail()
        }
      }
    },
    '$route':{
      immediate: true,
      deep: true,
      handler(val){
        this.activeTab = val.name
      }
    }
  },
  mounted() {
    if(this.$route.query.referral){
      this.activeTab = 'hdTab'
      this.handleClickTab()
    }
  },
  methods: {
    changeEmail(data){
      this.detailData.customer_profile.attached_change_account = data
    },
    handleRefresh(){
      this.activeTab = 'homeTab'
      this.network().getAccountDetail()
    },
    handlerRefresh(){
      this.isDot = true
    },
    handlerTab(tab) {
      this.activeTab = tab
      this.handleClickTab()
    },
    getEditProfile(data){
      this.detailData = data
    },
    switchActiveTab(target) {
      this.activeTab = target
      this.handleClickTab()
    },
    updateMessageData() {
      this.$refs['child'].updateData()
    },
    handlerAddRemark() {
      if (this.message) {
        this.network().addAccountRemark()
      }
    },
    newTicketClick() {
      this.$refs['new-general-ticket'].changeDialog()
    },
    changeAssignee(id) {
      id = id?id:0
      this.network().setAccountCs(id)
    },
    getUpdateAccountData() {
      this.network().getAccountDetail()
    },

    handleClickTab(){
      this.$router.push({
        name:this.activeTab,
        query:{
          customer_id: this.customerId,
        }
      })
    },

    editDescription(){
      this.$refs['edit-description'].changeDialog()
    },

    editUserBlocks(){
      this.$refs['edit-user-blocks'].changeDialog()
    },


    editFlag(){
      let params = {
        customer_id: this.customerId,
        is_flagged: this.detailData.customer_profile.is_flagged? 0 : 1
      }
      this.network().flagEdit(params)
    },
    network() {
      return {
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.customerId
          })
          this.detailData = data
          this.assigneeId = data.customer_profile.assignee_id
          if (data.remark) {
            this.remarkList = JSON.parse(JSON.stringify(data.remark))
          }

        },
        setAccountCs: async id => {
          const {data} = await setAccountCs({
            customer_id: this.customerId,
            assignee_id: id
          })
          this.$message({
            type: 'success',
            message: data.message_language
          })
        },
        addAccountRemark: async () => {
          const {data} = await addAccountRemark({
            customer_id: this.customerId,
            message: this.message
          })
          this.message = ''
          // todo 追加 remark
          this.remarkList.unshift(data)
        },
        flagEdit: async (params) => {
          const {data} = await flagEdit(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.getUpdateAccountData()
          }
        }
      }
    },
    changeApproveAccount() {
      this.$refs.approveAccount.changeApproveStatus()
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-main{
  padding: 0;
}
.detail-page-container {
  position: relative;
  margin: -20px;
  background: #fff;
  .top-bar {
    padding-top: 5px;
    color: #409eff;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #409eff;
  }

  .main-container {
    //margin-top: 20px;
    .hcid {
      display: inline-block;
      font-size: 14px;
      color: #586069;
      background: #fff;
      padding: 4px 10px;
      //border-radius: 4px;
      position: absolute;
      top: 0;
      left: 0;
      border-right: 1px solid #E1E4E8;
      border-bottom: 1px solid #E1E4E8;
      border-bottom-right-radius: 8px;
      font-weight: 600;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .main-header {
      //margin-bottom: 10px;
      padding: 30px 20px;
      padding-bottom: 0;
      background-color: #FAFBFC;
      margin-bottom: 15px;
      &.black{
        background: #24292E;
        color: white!important;
        span{
          color: white!important;
        }
        h3{
          color: white!important;
        }

        ::v-deep .el-tabs__header{
          .el-tabs__item{
            color: #fff;
          }
          .el-tabs__nav-wrap::after{
            background:none;
            color: white;
          }
        }
        .number-color{
          color: #fff;
        }

      }
      ::v-deep .el-tabs__header{
        margin: 0 !important;
      }
      .number-color{
        color: #000;
        font-weight: normal;
      }
      .header-title {
        display: flex;
        padding-bottom: 15px;
        align-items: center;
        .circle{
          box-sizing: border-box;
          border: 1px solid #E1E4E8;
          border-radius: 12px;
          background-color: #FFFFFF;
          color: #24292E!important;
          font-family: Inter;
          font-size: 12px;
          padding: 3px 10px;
          margin-left: 10px;
        }
        .icon {
          font-size: 18px;
          color: #6A737D;
          .orange{
            color: #E36209;
          }
        }
        .unname{
          font-style: italic;
          color: #6A737D;
          font-weight: 400;
        }

        h3 {
          padding-bottom: 0;
          padding: 0 15px;
          color: #24292E;
          font-weight: 600;
          font-size: 16px;
        }


      }

      .span-status {
        display: inline-block;
        margin-right: 15px;
        padding: 5px 10px;
        border-radius: 12px;
        font-size: 12px;
        line-height: 14px;
        color: white;
        font-weight: 500;
        &.green {
          background: #DCFFE4;
          color: #28A745;
          font-weight: 600;
        }

        &.orange {
          background-color:#FFF5B1 ;
          color:  #B08800;
          font-weight: 600;
        }


        &.red {
          background: #D73A49;
          color:#fff;
          font-weight: 600;
        }
        &.blue{
          color:#0366D6;
          border: 1px solid #0366D6;
          padding-top: 4px;
          padding-bottom: 4px;
        }
        &.verified{
          color:#22863a;
          border: 1px solid #22863a;
          padding-top: 4px;
          padding-bottom: 4px;
        }
        &.pending_verify{
          color:#dbab09;
          border: 1px solid #dbab09;
          padding-top: 4px;
          padding-bottom: 4px;
        }
        &.not_verify{
          color:#d73a49;
          border: 1px solid #d73a49;
          padding-top: 4px;
          padding-bottom: 4px;
        }
        &.flag{
          color:#C24E00;
          border: 1px solid #F66A0A;
          padding-top: 4px;
          padding-bottom: 4px;
        }

      }

      .header-date {
        padding-right: 15px;
        font-size: 14px;
        color: #586069;
        font-weight: 500;
        &.color-del{
          background: $del;
          color: #fff;
          border-radius: 4px;
          padding: 5px 10px;
        }
        &.fs-16{
          font-size: 16px;
        }
      }

      .header-label {
        display: inline-block;
        padding-right: 15px;
        color: #586069;
        font-size: 14px;
        font-weight: 500;
      }

      .top {
        display: flex;
        align-items: center;
        padding-bottom: 15px;

        h1 {
          padding-bottom: 0;
        }

        .company-logo {
          margin-right: 15px;
          height: 42px;

          img {
            height: 42px;
          }
        }
      }

      .info-container {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        border-top: 1px solid #dddfe7;

        & > div {
          font-size: 14px;
          color: #91939a;

          & > span:first-child {
            display: block;
            padding-bottom: 5px;
            font-size: 14px;
            font-weight: bold;
            color: #616266;
          }
        }
      }
    }
    .warning{
      margin: 0 20px;
    }
    .main-body {
      //display: flex;
      display: flex;
      padding: 20px;
      .main-content {
        width: calc(100% - 250px);
        margin-right: 15px;

        .status-bar {
          margin-bottom: 15px;
          padding: 15px;
          align-items: center;
          border-radius: 4px;
        }

        .status-bar-endorsement {
          background: #e6a23d;

          .left {
            color: white;

            span {
              display: block;
              font-size: 14px;

              &:first-child {
                font-size: 16px;
                font-weight: bold;
              }
            }
          }
        }

        .status-bar-blue {
          background: #e1efff;

          .left {
            color: #1d43a0;
            font-size: 14px;

            span:first-child {
              display: inline-block;
              padding-right: 15px;
              font-weight: bold;
            }
          }
        }

        .void-status {
          padding: 15px;
          background: #c81f1d;
          color: white;
          font-size: 14px;
          border-radius: 4px;

          span:first-child {
            display: inline-block;
            padding-right: 15px;
            font-weight: 500;
          }
        }
      }

      aside {
        margin-left: 15px;
        width: 250px;
        //margin-top: 50px;

        .card {
          margin-bottom: 15px;
          .el-button{
            width: 100%;
            & + .el-button{
              margin-left: 0;
              margin-top: 10px;
            }
          }
          /deep/.el-button.btn-gray{
            .icon{
              color: #586069;
            }
          }
          .flex-sb{
            span.title{
              padding-bottom: 0px;
            }
            span.edit{
              color: #0366D6;
              font-weight: 400;
              font-size: 14px;
              cursor: pointer;
            }
          }
          .description-content{
            font-weight: 400;
            font-size: 14px;
            color: #24292E;
          }
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .el-select {
          margin-bottom: 10px;
        }

        .el-input {
          margin-bottom: 10px;

          & + .el-button {
            margin-bottom: 10px;
          }
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }

        .remark-add {
          z-index: 2;
          margin: 0 -15px;
          padding: 15px 15px 0 15px;
          border-top: 1px solid #dddfe7;
        }

        .remarks-container {
          z-index: 1;
          max-height: 300px;
          overflow-y: auto;

          .remark-box {
            margin-bottom: 10px;
            font-size: 12px;
            color: #91939a;

            .remark-header {
              display: flex;
              justify-content: space-between;

              span:first-child {
                font-weight: bold;
              }
            }

            p {
              padding-bottom: 10px;
              color: #616266;
            }
          }
        }

      }
    }
  }

  .dialog-container {
    padding: 15px;
    color: #616266;

    h1 {
      font-size: 24px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;

      h1 {
        font-size: 24px;
      }
    }

    .dialog-content {
      padding-top: 15px;

      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }

  .backgroundCar {
    background: #FFFBDD;

    .title {
      color: #24292E;
      font-size: 14px;
      font-weight: normal !important;
    }
  }
  .flex-tab{
    display: flex;
    align-items: center;
    .dot{
      display: block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #409eff;
      margin-left: 10px;
    }
  }

}
.qr_avatar{
  display: flex;
  justify-content: center;
  width: 58px;
  height: 58px;
  border: 1px solid rgba(27, 31, 35, 0.15);;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;
  z-index: 2;
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
.text-italic{
  font-style: italic;
}
</style>
